export default __webpack_public_path__ + "static/media/filters-icon.43a12607.svg";